export default [{
		title: 'Кто есть кто в мире «Ходячих мертвецов»',
		text: '«Спасители», группа из Хилтопа, Королевство и Мусорщики',
		size: 'big',
		type: 'full',
		image: 'story1.jpg',
		link: '/kto-est-kto-v-mire-hodyachih-mertvecov'
	},
	{
		title: 'Если вас укусили',
		text: 'Советы для тех, кто хочет жить без ноги',
		size: 'small',
		type: 'full',
		image: 'story2.gif',
		link: '/chto-delat-esli-vas-ukusili'
	},
	{
		title: 'Памяти павших',
		text: 'Вспоминаем тех, кто пришелся по вкусу',
		size: 'small',
		type: 'full',
		image: 'story3.jpg',
		link: '/pamyati-pavshih'
	},
	{
		title: 'Вирусология',
		text: 'Откуда появился вирус и есть ли от него защита',
		size: 'small',
		type: 'full',
		image: 'story4.gif',
		link: '/otkuda-poyavilsya-virus'
	},
	{
		title: 'Голова с плеч',
		text: 'Чем лучше всего остановить зомби',
		size: 'small',
		type: 'full',
		image: 'story5.jpg',
		link: '/golova-s-plech'
	},
	{
		title: '100-й эпизод «Ходячих»:',
		text: 'Где его смотреть в мире, где пока еще нет зомби?',
		size: 'big',
		type: 'full',
		image: 'story6.jpg',
		link: '/100-epizodov-hodyachih'
	},
	{
		title: 'Все зло от людей',
		text: 'Что делать, если вас предал лучший друг',
		size: 'big',
		type: 'half',
		image: 'story7.jpg',
		link: '/vse-zlo-ot-lyudei'
	},
	{
		title: 'Здесь вам рады',
		text: 'Где можно спрятаться, если вы устали убивать зомби в лесах',
		size: 'small',
		type: 'half',
		image: 'story8.jpg',
		link: '/zdes-vam-radi'
	},
	{
		title: 'Партнерский материал',
		text: 'Лучшие бензопилы для защиты от зомби<br>в лесу',
		size: 'small',
		type: 'center',
		image: 'story9.jpg',
		link: '/'
	},
]



// WEBPACK FOOTER //
// ./src/data/stories.js